import { WinTeam } from "./WinTeam.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  WinTeam
};
//# sourceMappingURL=index.js.map
